import { siFigma } from "simple-icons";

// =============================================================================
// Filled icons of the services row (the design uses solid glyphs)
// =============================================================================

type IconProps = { className?: string };

export function WebIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden>
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <g
        fill="none"
        stroke="var(--background)"
        strokeWidth="1.6"
        strokeLinecap="round"
      >
        <path d="M2.5 12h19" />
        <path d="M12 2.2c2.7 2.6 4 6 4 9.8s-1.3 7.2-4 9.8" />
        <path d="M12 2.2c-2.7 2.6-4 6-4 9.8s1.3 7.2 4 9.8" />
      </g>
    </svg>
  );
}

export function DesignIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden>
      <path d={siFigma.path} fill="currentColor" />
    </svg>
  );
}

export function MobileIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden>
      <rect x="5" y="1.5" width="14" height="21" rx="3" fill="currentColor" />
      <path
        d="M10 18.8h4"
        stroke="var(--background)"
        strokeWidth="1.6"
        strokeLinecap="round"
      />
    </svg>
  );
}

export function DesktopIcon({ className }: IconProps) {
  return (
    <svg viewBox="0 0 24 24" className={className} aria-hidden>
      <rect x="1.5" y="3" width="21" height="14" rx="2.6" fill="currentColor" />
      <path
        d="M12 17v3.5M8 21h8"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}

// =============================================================================
